import { useSelector } from 'react-redux'

import { canShowVatTaxMessageSelector } from '@/selectors'

const VatTaxMessage = () => {
  const canShowVatTaxMessage = useSelector(canShowVatTaxMessageSelector)
  const vatTaxMessage = useSelector(state => state.taxes.vatTaxMessage)

  return (
    <If condition={canShowVatTaxMessage}>
      <div className='u-align--right type--orange font-5'>
        {vatTaxMessage}
      </div>
    </If>
  )
}

export default VatTaxMessage
